import React from 'react';
import '../../style/scss/App.scss';
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function PackageSelectionListItem(props) {
   debugger;
   const onClick = (e) => {
      if (props.onChange)
         props.onChange(props.id, e);
      if (props.onClick)
         props.onClick(props.id, e);
   }
   return (
      <div className={"packageSelection selectionPanel checkRow" + (props.selected ? ' selected' : '')} onClick={onClick}>
         <span className='icon'>
            <MdCheckBoxOutlineBlank size={1} color="#0075FF" className={props.selected ? 'hidden' : ''} />
            <MdOutlineCheckBox size={1} color="#0075FF" className={props.selected ? '' : 'hidden'} />
         </span>
         <span className='title'>{props.name}</span>
         <span className='byline'></span>
         <span className='rightText'></span>
      </div>
   );
}
